import { useCvpQueryClient } from "../api/queryClient";
import { authAPI } from "../api/auth";
import { CvpLocale } from "../constants/CvpLocale";
import { redirect } from "../url/redirect";
import { useWhoAmI } from "../user/useWhoAmI";

/**
 * Use this function to set the locale for the user.
 * For example from a menu where the user can choose between different languages.
 *
 * Use useSetLocale to get current locale
 * */
export function useSetLocale() {
  const { confirmedLoggedIn } = useWhoAmI();
  const cvpQueryClient = useCvpQueryClient();

  const setLocale = async (locale: CvpLocale) => {
    if (confirmedLoggedIn) {
      // sette locale med ny api metode (VTSWT-772)
      // fjerne cvplocale fra querystring (getRedirectProps)
      // fjerne sessionStorage.getItem("locale")
      await authAPI.saveLocaleChoice({
        locale,
      });
      sessionStorage.removeItem("locale");

      redirect(null, { mergeQs: { cvplocale: null } });
      cvpQueryClient.invalidateQueries();
    } else {
      // sette sessionStorage.getItem("locale")
      // fjerne cvplocale fra querystring (getRedirectProps)
      sessionStorage.setItem("locale", locale);
      redirect(null, { mergeQs: { cvplocale: null } });
      cvpQueryClient.invalidateQueries();
    }
  };

  return { setLocale };
}
